import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import SearchBox from '../courses/searchBox';
import { fetchRequest as getCourseRecomAction} from '../../store/courseRecommend/actions'
import { getCourseRecom } from '../../store/courseRecommend/selectors';
import {
    Container, Col, Row, Card, CardImg, CardTitle, CardText, CardGroup, CardFooter,
    CardSubtitle, CardBody, Spinner, Button
} from 'reactstrap';
import { NavLink as RouterNavLink } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.css';
import { Redirect } from 'react-router-dom';

interface PropsFromState {
    route: any
    data: any
    loading: boolean
    totalDoc: number
}

interface IState {
    redirect: boolean
    term : string
    profession : string
    country : string
    sorting : string
    offset: number
    limit: number
}

interface PropsFromDispatch {
    fetchRequest : typeof getCourseRecomAction
}

type AllProps = PropsFromState & PropsFromDispatch

class FAQ extends React.Component<AllProps, IState> {

    constructor(props: AllProps) {
        super(props);
        this.state = {
            term : '',
            profession : '',
            country:'',
            sorting: '',
            offset : 0,
            limit: 4,
            redirect: false
        };
        //this.Search = this.Search.bind(this);
    }

    public componentDidMount() {
        const { fetchRequest: fr, data } = this.props
        var searchParams:any = {};
        searchParams["offset"] = this.state.offset;
        searchParams["limit"] = this.state.limit;
        if (data.length === 0)
           fr(searchParams);
    }

    private Search(d:any) { 

       this.setState({
            offset : 0, 
            redirect : true,
            term : d.searchTerm.toLowerCase(), 
            profession : d.searchProfession, 
            country : d.searchCountry}, () => {
        });
    }
   
    public render() {

        if (this.state.redirect){
            return (
                <Redirect push to={{
                    pathname: '/courses/' ,
                    search :'?term=' + this.state.term  + "&profession=" + encodeURIComponent(this.state.profession) + "&country=" + this.state.country    
                }} />
                // <Redirect to={"/courses?term=" + this.state.term 
                //     + "&profession=" + this.state.profession
                //     + "&country=" + this.state.country    
                //  } />
            )
        }else{
            return (        
                <Container>
                    <h1>Frequently Asked Questions</h1>
                    <hr/>
                    <p>
                        Ultimates PRO is a one-stop e-learning platform for professionals. We offer personalize learning dashboards that gives you a high-impact learning experience ANYTIME, ANYWHERE.
                        Our mission is to enhance your knowledge by adapting current technology, latest information, as well as providing you with the skills you need to unlock your potential. 
                    </p>
                    <ol>
                        <li style={{fontWeight: "bold"}}>How do I take a course on Ultimates PRO learning?</li>
                        <p>
                            Our learning shelf is entirely on-demand, which means that you can enroll in the courses that interest you and learn at your own pace. You can begin the course whenever you like, but there are deadlines to complete it. After you are enrolled into the courses, you can access the training materials through the system. For steps on how to log into your account, please <a href='/#/how-it-works'>click here</a>.
                        </p>
                        <li style={{fontWeight: "bold"}}>How long do I have to complete each course?</li>
                        <p>
                            Every course has a certain deadline to meet. Once you complete the course, you will receive a notification via e-mail. If you did not complete the course on time, you will need to subscribe it again to get the full access.
                        </p>
                        <li style={{fontWeight: "bold"}}>Is there any training material course provided?</li>
                        <p>
                            Yes. You can download the training material just right next to the video, a button stating training material.
                        </p>
                        <li style={{fontWeight: "bold"}}>Can I replay the video after completion?</li>
                        <p>
                            Yes you can, the course can be replay until it expired.
                        </p>
                        <li style={{fontWeight: "bold"}}>What if I don’t like a course I purchased?</li>
                        <p>
                            There is a no refund after you purchase the course. Please <a href='/#/terms-of-use'>click here</a> for more information regarding about the no refund policy.
                        </p>
                        <li style={{fontWeight: "bold"}}>Can I subscribe for few courses at one time?</li>
                        <p>
                            Yes, you can. As long as you can finish the courses in the designated time frame.
                        </p>

                        <li style={{fontWeight: "bold"}}>Do I get a certification after completion?</li>
                        <p>
                            Yes, you do. When each course is completed, there will a notification in your profile column indicating that your certificate is ready.
                        </p>
                        <li style={{fontWeight: "bold"}}>I’ve have problems downloading the certificate. Why?</li>
                        <p>
                            Occasionally, the system may need a minute to generate a certificate after a course has been completed. Wait a couple of minutes and then try clicking on the icon again. You may also need to refresh the page, or clear your cache and cookies, in order to see your certificate.
                        </p>
                        <li style={{fontWeight: "bold"}}>Can I do the Ultimates Pro Courses from my tablet or smartphone?</li>
                        <p>
                            Yes. For better viewing, please use laptop/PC.
                        </p>
                        <li style={{fontWeight: "bold"}}>Still have questions?</li>
                        <address>
                            
                            Email us at <a href="mailto:feedback@ultimatespro.com.my">feedback@ultimatespro.com.my</a>
                        </address>
                    </ol>
                    <br /><br /><br /><br /><br /><br /><br />
                </Container>
            )
        }
    }
}

const mapStateToProps = (state: ApplicationState) => ({
    loading: state.course.ui.loading,
    totalDoc: state.course.ui.totDoc,
    errors: state.course.ui.errors,
    data: getCourseRecom(state)
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    fetchRequest: getCourseRecomAction
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FAQ)
